import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import ScrollView from '../../atoms/ScrollView'
import HRule from '../../atoms/HRule'
import TextCallout from '../../molecules/TextCallout'
import Paper from '../../atoms/Paper'
import RegisterTemplate from '../../templates/RegisterTemplate'
import TermsAndPrivacyNotice from '../../molecules/TermsAndPrivacyNotice'
import LogoTitle from '../../molecules/LogoTitle'
import medias from '../../../util/medias'

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

const HRuleWrapper = styled(View)`
  margin-top: 24px;
  margin-right: 0;
  margin-bottom: 24px;
  margin-left: 0;
`

const FooterWrapper = styled(View)`
  margin-top: 24px;
`

export const RegisterPage = props => {
  const {
    onRegisterSuccess,
    onRequireEmail,
    onSubmit,
    onLoginClick,
    onError,
    facebookAppId,
    abTests,
    emailExistTest,
    passwordlessSignIn,
    onSendEmailSuccess,
    onPhoneNotValidatedError,
    onAccountSocialLoginTyping,
    onAccountCompleteData,
  } = props

  return (
    <ScrollView>
      <Content>
        <Paper>
          <LogoTitle title="Crie a sua conta. É grátis!" />
          <RegisterTemplate
            onRegisterSuccess={onRegisterSuccess}
            onSubmit={onSubmit}
            onError={onError}
            facebookAppId={facebookAppId}
            onRequireEmail={onRequireEmail}
            abTests={abTests}
            emailExistTest={emailExistTest}
            passwordlessSignIn={passwordlessSignIn}
            onSendEmailSuccess={onSendEmailSuccess}
            onPhoneNotValidatedError={onPhoneNotValidatedError}
            onAccountSocialLoginTyping={onAccountSocialLoginTyping}
            onAccountCompleteData={onAccountCompleteData}
          />
          <HRuleWrapper>
            <HRule />
          </HRuleWrapper>
          <TextCallout
            text="Já tem uma conta?"
            linkText="Entrar"
            href="/acesso"
            onClick={onLoginClick}
          />
        </Paper>
        <FooterWrapper>
          <TermsAndPrivacyNotice />
        </FooterWrapper>
      </Content>
    </ScrollView>
  )
}

RegisterPage.propTypes = {
  onRegisterSuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  onRequireEmail: PropTypes.func,
  onLoginClick: PropTypes.func,
  onError: PropTypes.func,
  facebookAppId: PropTypes.string.isRequired,
  abTests: PropTypes.string,
  emailExistTest: PropTypes.bool,
  passwordlessSignIn: PropTypes.bool,
  onSendEmailSuccess: PropTypes.func,
  onPhoneNotValidatedError: PropTypes.func,
  onAccountSocialLoginTyping: PropTypes.func,
  onAccountCompleteData: PropTypes.func,
}
